import React, { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { useLocales } from '../../../../../hooks';
import { FormBody, SectionHeader } from '../../styles';
import { UIModuleTypeForm } from '../../UIModuleForm';
import { SubscriptionPlanDetailsUiModuleBody } from '../../../../../API';
import { Box } from '@mui/material';
import { LokaliseField } from '../../../../shared/LokaliseFields';
import { subscriptionPlanDetailsFormTestIds } from '../../../../shared/TestsIds';

const SubscriptionPlanDetailsForm = forwardRef<UIModuleTypeForm<SubscriptionPlanDetailsUiModuleBody>>(() => {
  const { control } = useFormContext<SubscriptionPlanDetailsUiModuleBody>();
  const { t } = useLocales();

  return (
    <FormBody data-testid={subscriptionPlanDetailsFormTestIds.formBody}>
      <SectionHeader>{t('layouts.subscription_plan_details.headers.new_promo')}</SectionHeader>
      <Box>
        <LokaliseField
          name="priceTitle"
          control={control}
          toTranslate="layouts.subscription_plan_details.fields"
          dataTestId={subscriptionPlanDetailsFormTestIds.formField('priceTitle')}
          required
        />
        <LokaliseField
          name="price"
          control={control}
          toTranslate="layouts.subscription_plan_details.fields"
          dataTestId={subscriptionPlanDetailsFormTestIds.formField('price')}
          required
        />
        <LokaliseField
          name="deviceLimitTitle"
          control={control}
          toTranslate="layouts.subscription_plan_details.fields"
          dataTestId={subscriptionPlanDetailsFormTestIds.formField('deviceLimitTitle')}
          required
        />
        <LokaliseField
          name="deviceLimit"
          control={control}
          toTranslate="layouts.subscription_plan_details.fields"
          dataTestId={subscriptionPlanDetailsFormTestIds.formField('deviceLimit')}
          required
        />
        <LokaliseField
          name="adsDisclaimerTitle"
          control={control}
          toTranslate="layouts.subscription_plan_details.fields"
          dataTestId={subscriptionPlanDetailsFormTestIds.formField('adsDisclaimerTitle')}
          required
        />
        <LokaliseField
          name="adsDisclaimer"
          control={control}
          toTranslate="layouts.subscription_plan_details.fields"
          dataTestId={subscriptionPlanDetailsFormTestIds.formField('adsDisclaimer')}
          required
        />
        <LokaliseField
          name="contentDisclaimerTitle"
          control={control}
          toTranslate="layouts.subscription_plan_details.fields"
          dataTestId={subscriptionPlanDetailsFormTestIds.formField('contentDisclaimerTitle')}
          required
        />
        <LokaliseField
          name="contentDisclaimer"
          control={control}
          toTranslate="layouts.subscription_plan_details.fields"
          dataTestId={subscriptionPlanDetailsFormTestIds.formField('contentDisclaimer')}
          required
        />
        <LokaliseField
          name="downloadDisclaimerTitle"
          control={control}
          toTranslate="layouts.subscription_plan_details.fields"
          dataTestId={subscriptionPlanDetailsFormTestIds.formField('downloadDisclaimerTitle')}
          required
        />
        <LokaliseField
          name="downloadDisclaimer"
          control={control}
          toTranslate="layouts.subscription_plan_details.fields"
          dataTestId={subscriptionPlanDetailsFormTestIds.formField('downloadDisclaimer')}
          required
        />
        <LokaliseField
          name="valuePropositionTitle"
          control={control}
          toTranslate="layouts.subscription_plan_details.fields"
          dataTestId={subscriptionPlanDetailsFormTestIds.formField('valuePropositionTitle')}
          required
        />
        <LokaliseField
          name="valueProposition"
          control={control}
          toTranslate="layouts.subscription_plan_details.fields"
          dataTestId={subscriptionPlanDetailsFormTestIds.formField('valueProposition')}
          required
        />
        <LokaliseField
          name="legalDisclosure"
          control={control}
          toTranslate="layouts.subscription_plan_details.fields"
          dataTestId={subscriptionPlanDetailsFormTestIds.formField('legalDisclosure')}
          required
        />
        <LokaliseField
          name="planTitle"
          control={control}
          toTranslate="layouts.subscription_plan_details.fields"
          dataTestId={subscriptionPlanDetailsFormTestIds.formField('planTitle')}
          required
        />
        <LokaliseField
          name="planSubtitle"
          control={control}
          toTranslate="layouts.subscription_plan_details.fields"
          dataTestId={subscriptionPlanDetailsFormTestIds.formField('planSubtitle')}
          required
        />
        <LokaliseField
          name="sportsDisclaimerTitle"
          control={control}
          toTranslate="layouts.subscription_plan_details.fields"
          dataTestId={subscriptionPlanDetailsFormTestIds.formField('sportsDisclaimerTitle')}
          required
        />
        <LokaliseField
          name="sportsDisclaimer"
          control={control}
          toTranslate="layouts.subscription_plan_details.fields"
          dataTestId={subscriptionPlanDetailsFormTestIds.formField('sportsDisclaimer')}
          required
        />
      </Box>
    </FormBody>
  );
});

SubscriptionPlanDetailsForm.displayName = 'SubscriptionPlanDetailsForm';

export default SubscriptionPlanDetailsForm;
